<ci-sub-header title="AMPERE Workaround"></ci-sub-header>

<div class="sub-nav-bar">
  <coin-v2-button
    [type]="openList === 'transfer' ? 'primary' : 'secondary'"
    [text]="'Transfer List'"
    [icon]="'chevron_right'"
    [iconPos]="'right'"
    (click)="openTransferListPage()"></coin-v2-button>

  <coin-v2-button
    [type]="openList === 'structure' ? 'primary' : 'secondary'"
    [text]="'Structure List'"
    [icon]="'chevron_right'"
    [iconPos]="'right'"
    (click)="openStructureListPage()"></coin-v2-button>

  <coin-v2-button
    [type]="openList === 'email' ? 'primary' : 'secondary'"
    [text]="'Email List'"
    [icon]="'chevron_right'"
    [iconPos]="'right'"
    (click)="openEmailListPage()"></coin-v2-button>
</div>

@if (openList === 'transfer') {
  <ci-transfer_list></ci-transfer_list>
}
@if (openList === 'structure') {
  <ci-structure_list></ci-structure_list>
}
@if (openList === 'email') {
  <ci-email_list></ci-email_list>
}
